/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AccessKeyResponseDto,
  AccountPaymentMethodsResponseDto,
  AccountPlatformResponseDto,
  AccountRegistryRequestDto,
  AccountResponseDto,
  AccountWidgetSettingResponse,
  CommonResponseDto,
  CustomRedirectResponseDto,
  GetAccountParams,
  HTTPValidationError,
  UpdateAccountPlatformRequestDto,
  UpdateApiKeyRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 회원을생성하는API
 * @summary Register
 */
export const registerAccount = (
    accountRegistryRequestDto: AccountRegistryRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CustomRedirectResponseDto>(
      {url: `/account/register-account`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountRegistryRequestDto
    },
      options);
    }
  


export const getRegisterAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerAccount>>, TError,{data: AccountRegistryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof registerAccount>>, TError,{data: AccountRegistryRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerAccount>>, {data: AccountRegistryRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  registerAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterAccountMutationResult = NonNullable<Awaited<ReturnType<typeof registerAccount>>>
    export type RegisterAccountMutationBody = AccountRegistryRequestDto
    export type RegisterAccountMutationError = HTTPValidationError

    /**
 * @summary Register
 */
export const useRegisterAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerAccount>>, TError,{data: AccountRegistryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerAccount>>,
        TError,
        {data: AccountRegistryRequestDto},
        TContext
      > => {

      const mutationOptions = getRegisterAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 어카운트정보를가져오는API
 * @summary GetAccount
 */
export const getAccount = (
    params?: GetAccountParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccountResponseDto>(
      {url: `/account/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAccountQueryKey = (params?: GetAccountParams,) => {
    return [`/account/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = HTTPValidationError


export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params: undefined |  GetAccountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccount
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(params?: GetAccountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountSuspenseQueryError = HTTPValidationError


export function useGetAccountSuspense<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params: undefined |  GetAccountParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSuspense<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountSuspense<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccount
 */

export function useGetAccountSuspense<TData = Awaited<ReturnType<typeof getAccount>>, TError = HTTPValidationError>(
 params?: GetAccountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 계정을삭제하는API(복구불가)
 * @summary DeleteAccount
 */
export const deleteAccount = (
    
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/account/`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, void> = () => {
          

          return  deleteAccount(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>
    
    export type DeleteAccountMutationError = HTTPValidationError

    /**
 * @summary DeleteAccount
 */
export const useDeleteAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 어카운트의위젯기본세팅을가져오는API
 * @summary GetAccountWidgetSetting
 */
export const getAccountWidgetSetting = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccountWidgetSettingResponse>(
      {url: `/account/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountWidgetSettingQueryKey = () => {
    return [`/account/settings`] as const;
    }

    
export const getGetAccountWidgetSettingQueryOptions = <TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountWidgetSettingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountWidgetSetting>>> = ({ signal }) => getAccountWidgetSetting(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountWidgetSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountWidgetSetting>>>
export type GetAccountWidgetSettingQueryError = HTTPValidationError


export function useGetAccountWidgetSetting<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountWidgetSetting>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountWidgetSetting<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountWidgetSetting>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountWidgetSetting<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountWidgetSetting
 */

export function useGetAccountWidgetSetting<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountWidgetSettingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountWidgetSettingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountWidgetSettingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountWidgetSetting>>> = ({ signal }) => getAccountWidgetSetting(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountWidgetSettingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountWidgetSetting>>>
export type GetAccountWidgetSettingSuspenseQueryError = HTTPValidationError


export function useGetAccountWidgetSettingSuspense<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountWidgetSettingSuspense<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountWidgetSettingSuspense<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountWidgetSetting
 */

export function useGetAccountWidgetSettingSuspense<TData = Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountWidgetSetting>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountWidgetSettingSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 어카운트의쇼핑몰정보를가져오는API
 * @summary GetAccountPlatform
 */
export const getAccountPlatform = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccountPlatformResponseDto>(
      {url: `/account/platform`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountPlatformQueryKey = () => {
    return [`/account/platform`] as const;
    }

    
export const getGetAccountPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountPlatformQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountPlatform>>> = ({ signal }) => getAccountPlatform(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountPlatform>>>
export type GetAccountPlatformQueryError = HTTPValidationError


export function useGetAccountPlatform<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPlatform<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPlatform<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountPlatform
 */

export function useGetAccountPlatform<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountPlatformQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountPlatformQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountPlatform>>> = ({ signal }) => getAccountPlatform(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountPlatform>>>
export type GetAccountPlatformSuspenseQueryError = HTTPValidationError


export function useGetAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountPlatform
 */

export function useGetAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getAccountPlatform>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountPlatformSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 쇼핑몰정보수정API
 * @summary UpdateAccountPlatform
 */
export const updateAccountPlatform = (
    updateAccountPlatformRequestDto: UpdateAccountPlatformRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/account/platform`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountPlatformRequestDto
    },
      options);
    }
  


export const getUpdateAccountPlatformMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountPlatform>>, TError,{data: UpdateAccountPlatformRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountPlatform>>, TError,{data: UpdateAccountPlatformRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountPlatform>>, {data: UpdateAccountPlatformRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountPlatform(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountPlatform>>>
    export type UpdateAccountPlatformMutationBody = UpdateAccountPlatformRequestDto
    export type UpdateAccountPlatformMutationError = HTTPValidationError

    /**
 * @summary UpdateAccountPlatform
 */
export const useUpdateAccountPlatform = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountPlatform>>, TError,{data: UpdateAccountPlatformRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountPlatform>>,
        TError,
        {data: UpdateAccountPlatformRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateAccountPlatformMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 어카운트의엑세스키를가져오는API
 * @summary GetAccountAccessKey
 */
export const getAccountAccessKey = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccessKeyResponseDto>(
      {url: `/account/access-key`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountAccessKeyQueryKey = () => {
    return [`/account/access-key`] as const;
    }

    
export const getGetAccountAccessKeyQueryOptions = <TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountAccessKeyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountAccessKey>>> = ({ signal }) => getAccountAccessKey(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountAccessKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountAccessKey>>>
export type GetAccountAccessKeyQueryError = HTTPValidationError


export function useGetAccountAccessKey<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountAccessKey>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountAccessKey<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountAccessKey>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountAccessKey<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountAccessKey
 */

export function useGetAccountAccessKey<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountAccessKeyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountAccessKeySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountAccessKeyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountAccessKey>>> = ({ signal }) => getAccountAccessKey(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountAccessKeySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountAccessKey>>>
export type GetAccountAccessKeySuspenseQueryError = HTTPValidationError


export function useGetAccountAccessKeySuspense<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountAccessKeySuspense<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountAccessKeySuspense<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountAccessKey
 */

export function useGetAccountAccessKeySuspense<TData = Awaited<ReturnType<typeof getAccountAccessKey>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountAccessKey>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountAccessKeySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 어카운트의쇼핑몰정보를가져오는API
 * @summary GetAccountPaymentMethod
 */
export const getAccountPaymentMethod = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<AccountPaymentMethodsResponseDto>(
      {url: `/account/payment/methods`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountPaymentMethodQueryKey = () => {
    return [`/account/payment/methods`] as const;
    }

    
export const getGetAccountPaymentMethodQueryOptions = <TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountPaymentMethodQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountPaymentMethod>>> = ({ signal }) => getAccountPaymentMethod(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountPaymentMethod>>>
export type GetAccountPaymentMethodQueryError = HTTPValidationError


export function useGetAccountPaymentMethod<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountPaymentMethod>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPaymentMethod<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountPaymentMethod>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPaymentMethod<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountPaymentMethod
 */

export function useGetAccountPaymentMethod<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountPaymentMethodQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAccountPaymentMethodSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountPaymentMethodQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountPaymentMethod>>> = ({ signal }) => getAccountPaymentMethod(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountPaymentMethodSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountPaymentMethod>>>
export type GetAccountPaymentMethodSuspenseQueryError = HTTPValidationError


export function useGetAccountPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetAccountPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetAccountPaymentMethod
 */

export function useGetAccountPaymentMethodSuspense<TData = Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccountPaymentMethod>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountPaymentMethodSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 플랫폼연동API-KEY수정API
 * @summary UpdateApiKey
 */
export const updateApiKey = (
    updateApiKeyRequestDto: UpdateApiKeyRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/account/api-key`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateApiKeyRequestDto
    },
      options);
    }
  


export const getUpdateApiKeyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: UpdateApiKeyRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: UpdateApiKeyRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApiKey>>, {data: UpdateApiKeyRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateApiKey(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof updateApiKey>>>
    export type UpdateApiKeyMutationBody = UpdateApiKeyRequestDto
    export type UpdateApiKeyMutationError = HTTPValidationError

    /**
 * @summary UpdateApiKey
 */
export const useUpdateApiKey = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: UpdateApiKeyRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateApiKey>>,
        TError,
        {data: UpdateApiKeyRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateApiKeyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    